export default __webpack_public_path__ + "static/media/illustrate-document-jpeg.a8280107.svg";